










import Vue from 'vue'
import Component from 'vue-class-component'
import { AppModule } from '@app/componentlib/src/store/modules/app'
import { JobSearchModule } from '@app/componentlib/src/store/modules/jobSearch'
import { ISearchParams } from '@app/componentlib/common/types/JobSearchTypes'

@Component<SearchFilterRadioButtons>({})

export default class SearchFilterRadioButtons extends Vue {
  /**
   * Props variables
   */


  /**
   * Component state variables
   */


  /**
   * Lifecycle
   */


  /**
   * Getters
   */
   get t (): any {
    return AppModule.translations
  }

  get isMobile (): boolean {
    return AppModule.isMobile
  }

  get searchParams (): ISearchParams {
    return JobSearchModule.searchParams
  }

  get textSearch (): boolean {
    return this.searchParams.TextSearch
  }

  get matchAll (): boolean {
    return this.searchParams.MatchAll
  }

  /**
   * Methods
   */
   clickedItem(groupClicked: string ,item: boolean) {
    let params = this.searchParams

    if (groupClicked === 'matchall')
      params.MatchAll = item
    else if (groupClicked === 'textsearch')
      params.TextSearch = item

    JobSearchModule.setSearchParams(params)
  }
}
